<template>
    <div class="page">
        <van-nav-bar
                title="跟团游列表"
                left-text="返回"
                left-arrow
                fixed
                placeholder
                @click-left="onClickLeft"
        />
        <div class="list-box">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="暂无更多数据"
                        @load="onLoad"
                >
                    <van-cell v-for="item in list" :key="item.id" class="tour-cell" is-link @click="onItemClick(item)">
                        <template #title>
                            <div class="cell-title">{{ item.productName }}</div>
                        </template>
                        <template #label>
                            <div class="cell-info">
                                <span class="info-tag">行程 {{ item.dayNums }} 天</span>
                                <span class="info-tag">里程 {{ item.routeMileage }}km</span>
                            </div>
                        </template>
                    </van-cell>
                </van-list>
            </van-pull-refresh>
            <van-empty v-if="list.length === 0 && finished" description="暂无数据" />
        </div>
    </div>
</template>

<script>
    import {NavBar, List, Cell, Empty, PullRefresh} from 'vant';
    import {akGroupTourList} from '@/api/groupTour';

    export default {
        name: "groupTourList",
        components: {
            [NavBar.name]: NavBar,
            [List.name]: List,
            [Cell.name]: Cell,
            [Empty.name]: Empty,
            [PullRefresh.name]: PullRefresh
        },
        data() {
            return {
                list: [],
                loading: false,
                finished: false,
                refreshing: false,
                pageNum: 0,
                pageSize: 10
            };
        },
        methods: {
            onClickLeft() {
                this.$router.go(-1)
            },
            onRefresh() {
                this.list = []
                this.pageNum = 0
                this.finished = false
                this.loading = true
                this.getList()
            },
            onLoad() {
                this.pageNum += 1
                this.getList()
            },
            getList() {
                akGroupTourList({
                    pageNum: this.pageNum,
                    pageSize: this.pageSize
                }).then(res => {
                    const list = res && res.list ? res.list : []
                    this.list = this.list.concat(list)
                    this.loading = false
                    this.refreshing = false
                    if (list.length < this.pageSize) {
                        this.finished = true
                    }
                }).catch(() => {
                    this.loading = false
                    this.refreshing = false
                    this.finished = true
                })
            },
            onItemClick(item) {
                this.$router.push({ name: 'groupTourDetail', query: { id: item.id } })
            }
        }
    }
</script>

<style scoped lang="scss">
    .page {
        min-height: 100vh;
        background: #f5f7fa;
    }
    .list-box {
        padding: 0;
    }
    .tour-cell {
        background: #fff;
        margin-bottom: 8px;
    }
    .cell-title {
        font-size: 16px;
        font-weight: bold;
        color: #333;
    }
    .cell-info {
        margin-top: 6px;
        display: flex;
        gap: 8px;
    }
    .info-tag {
        font-size: 12px;
        color: #666;
        background: #f0f2f5;
        padding: 2px 8px;
        border-radius: 4px;
    }
</style>
